/**
 * Builds the composite key used to store/retrieve a single telemetry
 * parameter reading for one device + battery slave combination.
 *
 * Includes deviceId because slave IDs are derived from the asset model
 * string (see assetConfig.js) and are commonly shared across vehicles of
 * the same model — e.g. two "2DEYE2GCE9M" vehicles both expose slave IDs
 * 3 and 4. Keying on slaveId + paramKey alone would collapse both
 * vehicles' readings into a single series.
 */
export function buildParamKey(deviceId, slaveId, paramKey) {
  return `${deviceId}_${slaveId}_${paramKey}`;
}
